import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React, { Component, Fragment } from 'react';
import { MdClose, MdMenu } from 'react-icons/md';
import { MainMenuItem } from './MainMenuItem';
import { ArcaRedirect } from '../../../code/ArcaRedirect';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';

export class MainMenuDropdown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    render() {
        let { isOpen } = this.state;
        let isAdmin = ArcaSecurity.IsAdmin;
        let isLoggedIn = ArcaSecurity.IsLoggedIn;
        let isSmartphone = ArcaHttpSystem.IsSmartphone;

        let items = [
            { execute: true, name: 'home', label: 'Home', onClick: (() => ArcaRedirect.Push('/')) },

            { execute: isLoggedIn, name: 'You', label: 'Your details', onClick: (() => ArcaRedirect.Push('/PersonView?id=' + ArcaSecurity.UserId)) },
            { execute: isLoggedIn, name: 'You', label: 'Bookings', onClick: (() => ArcaRedirect.Push('/PersonView?id=' + ArcaSecurity.UserId + '&tab=OwnerWeekPlan')) },

            { execute: !isAdmin, name: 'services', label: 'Our services', onClick: (() => ArcaRedirect.Push('/OurServices')) },
            { execute: !isAdmin, name: 'meetTheTeam', label: 'Meet the team', onClick: (() => ArcaRedirect.Push('/MeetTheTeam')) },
            { execute: !isAdmin, name: 'testimonials', label: 'Testimonials', onClick: (() => ArcaRedirect.Push('/Testimonials')) },
            { execute: !isAdmin, name: 'equipment', label: 'Equipment', onClick: (() => ArcaRedirect.Push('/Equipment')) },

            { execute: !isLoggedIn || ArcaSecurity.IsWalker || ArcaSecurity.IsAdmin, name: 'contactUs', label: 'Contact us', onClick: (() => ArcaRedirect.Push('/Enquire')) },
            { execute: !isLoggedIn, name: 'Login', label: 'Login', onClick: (() => ArcaRedirect.Push('/Login')) },

            { execute: isAdmin, name: 'Prospects', label: 'Prospects', onClick: (() => ArcaRedirect.Push('/Prospects')) },
            { execute: isAdmin, name: 'Onboarding', label: 'Onboarding', onClick: (() => ArcaRedirect.Push('/Onboarding')) },
            { execute: isAdmin, name: 'Owners', label: 'Owners', onClick: (() => ArcaRedirect.Push('/OwnerList')) },
            { execute: isLoggedIn && !isAdmin && ArcaSecurity.IsOwner, name: 'serviceinfo', label: 'Service Info', onClick: (() => ArcaRedirect.Push('/ServiceInfo')) },
            { execute: isAdmin, name: 'Admin', label: 'Admin screen', onClick: (() => ArcaRedirect.Push('/Admin')) },
            { execute: isAdmin, name: 'Planning', label: 'Planning', onClick: (() => ArcaRedirect.Push('/Planning')) },
            { execute: isLoggedIn, name: 'Logout', label: 'Logout', onClick: (() => { ArcaSecurity.Logoff(); ArcaRedirect.Push('/') }) },

            { execute: false, name: 'search', label: 'Search', onClick: (() => ArcaRedirect.Push('/SearchDb')) },
            { execute: false, name: 'On-booarding', label: 'On-boarding', onClick: (() => ArcaRedirect.Push('/Onboardlist')) },
            { execute: false, name: 'Pages', label: 'Pages', onClick: (() => ArcaRedirect.Push('/EditPageDetails')) },
            { execute: false, name: 'Groups', label: 'Groups', onClick: (() => ArcaRedirect.Push('/GroupEditor')) },
            { execute: false, name: 'Walkers', label: 'Walkers', onClick: (() => ArcaRedirect.Push('/WalkerList')) },
        ]

        /* execute: isAdmin, name: 'Logging', label: 'Logging', onClick: (() => ArcaRedirect.Push('/Logging')), */ 

        return (
            <Fragment>
                <span
                    style={{ cursor: 'pointer', float: 'right' }}>
                    <MdMenu
                        size={isSmartphone ? '30px' : '50px'}
                        color='#EF711D'
                        onClick={() => this.setState({ isOpen: !isOpen })} />
                </span>

                {isOpen
                    ?
                    <Fragment>

                        <div className="sidebar">
                            <List disablePadding dense>

                                <ListItem key='Close' button >
                                    <ListItemText onClick={() => this.setState({ isOpen: false })}>
                                        <div className='sidebarMenuText'>
                                            Close <MdClose size={'38px'} />
                                        </div>

                                    </ListItemText>
                                </ListItem>

                                <MainMenuItem text={' '} />

                                {items.map(({ execute, label, name, onClick, ...rest }, k) => (

                                    <Fragment key={k}>
                                        {execute
                                            ? <MainMenuItem
                                                text={label}
                                                onClick={() => { onClick(); this.setState({ isOpen: false }) }} />
                                            : null}
                                    </Fragment>

                                ))}
                            </List>
                        </div>


                        {/* <Container className='mainMenu' >
                            <Row>
                                <Col>
                                    <ArcaLink icon={<FaHome size={size} className={colourClass} />} text='Home' link='/' onClick={this.props.onSelected} />
                                    <ArcaLink icon={<FaHome size={size} className={colourClass} />} text='Home' link='/' onClick={this.props.onSelected} />
                                </Col>
                            </Row>
                        </Container> */}
                    </Fragment>
                    : null}
            </Fragment>
        );
    }
}